import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_WELCOME_PAGE_REDIRECTS_ROUTE_NAME = Symbol('admin.welcome-page-redirects');
export const TRANSLATION_GROUP_WELCOME_PAGE_REDIRECTS = Symbol('admin.welcome-page-redirects');

export const WELCOME_PAGE_REDIRECTS_LIST_QUERY_KEY = 'admin.welcome-page-redirects.list';
export const WELCOME_PAGE_REDIRECTS_LIST_API_URL = 'admin/welcome_page_redirects/list';

export const WELCOME_PAGE_REDIRECTS_SAVE_MUTATION_KEY = 'admin.welcome-page-redirects.save';
export const WELCOME_PAGE_REDIRECTS_SAVE_API_URL = 'admin/welcome_page_redirects/save';

export const WELCOME_PAGE_REDIRECTS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.WELCOME_PAGE_REDIRECTS_SHOW),
  EDIT: new Permission(PermissionsList.admin.WELCOME_PAGE_REDIRECTS_EDIT),
};
